import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ValidatorListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ValidatorListPage extends Component<ValidatorListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.validator.list }}
                pages={{
                    entity: InferenceEntities.validator(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}